import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SurveyCategoryForm from './SurveyCategoryForm';
import { surveyCategoryService } from '../../services/surveyCategoryService';

const SurveyCategoriesPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const mode = location.state?.mode || 'create';
  const surveyId = location.state?.surveyId;
  const categoryToEdit = location.state?.categoryToEdit || null;

  const handleSubmit = async (data) => {
    try {
      if (mode === 'edit') {
        await surveyCategoryService.updateSurveyCategory(data.id, data);
      } else {
        await surveyCategoryService.createSurveyCategory(data);
      }
      navigate('/survey-categories-manager', { state: { selectedSurveyId: data.surveyId || surveyId } });
    } catch (error) {
      console.error('Error saving category:', error);
    }
  };

  const handleCancel = () => {
    navigate('/survey-categories-manager', { state: { selectedSurveyId: data.surveyId || surveyId } });
  };

  return (
    <div className="p-6 bg-gradient-to-br from-blue-50 via-white to-blue-50 min-h-screen">
      <h1 className="text-2xl font-bold text-gray-900 mb-6">
        {mode === 'edit' ? 'Edit Category' : 'Create New Category'}
      </h1>

      <SurveyCategoryForm
        surveyId={surveyId}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        initialData={categoryToEdit}
        isEditing={mode === 'edit'}
      />
    </div>
  );
};

export default SurveyCategoriesPage;
